import React, { useState } from 'react';
import { Card, CardContent } from './ui/Card';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
import MatrixRain from './MatrixRain';

const LoginForm = ({ onLogin, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(username, password);
  };

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center px-xl py-2xl relative overflow-hidden">
      <MatrixRain />

      <div className="relative z-10 w-full max-w-[380px] animate-scale-in">
        {/* Бренд */}
        <div className="text-center mb-2xl">
          <div className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-primary text-primary-fg shadow-md mb-lg">
            <i className="bi bi-soundwave text-xl" aria-hidden="true" />
          </div>
          <h1 className="text-page-title font-semibold text-text-strong">AdminSoundTT</h1>
          <p className="eyebrow mt-sm">Анализ музыкальных ссылок</p>
        </div>

        <Card className="shadow-lg">
          <CardContent className="p-2xl">
            <form onSubmit={handleSubmit} className="space-y-xl">
              <Input
                id="login-user"
                label="Логин"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
              />
              <Input
                id="login-pass"
                label="Пароль"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />

              {error && (
                <div
                  role="alert"
                  className="flex items-start gap-md p-lg rounded-md bg-destructive-soft border border-destructive/30 animate-fade-in"
                >
                  <i className="bi bi-exclamation-triangle text-destructive" aria-hidden="true" />
                  <p className="text-body-sm text-destructive">{error}</p>
                </div>
              )}

              <Button type="submit" variant="primary" size="lg" className="w-full justify-center">
                Войти
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LoginForm;
